<style lang="scss" scoped>
.pay_success_page {
	min-height: calc(100vh - 2.6rem);
	.icon {
		width: 1.45rem;
		height: 1.45rem;
		margin: 1.6rem auto 0.5rem;
		background: url(../assets/icon/success.png);
		background-repeat: no-repeat;
		background-size: 100%;
		background-position: center;
	}
	.text {
		font-size: 0.3rem;
		color: #052433;
		line-height: 0.3rem;
		font-weight: bold;
		text-align: center;
	}
}
</style>

<template>
	<div>
		<div class="pay_success_page">
			<div class="icon"></div>
			<div class="text">支付成功</div>
			<wxAccount />
		</div>
		<div class="tip_copyright">本系统已获软件著作权，受《中华人民共和国著作权法》和《计算机软件保护条例》的保护，未经许可请勿擅自使用、复制、传播软件。</div>
	</div>
	
</template>

<script>
import wxAccount from '../components/wxAccount.vue';
export default {
	name: 'paySuccess', // 支付成功页面
	components: { wxAccount },
	data() {
		return {};
	},
	created() {
		console.log(this.$route.params);
	},
	methods: {},
};
</script>
